import { Box, Stack } from "@mui/material";
import PrintThemeProvider from "./print-theme-provider";
import { ReactNode, Ref } from "react";

export interface BasePrinterProps {
    printer: {
        printRef: Ref<HTMLElement>,
        printComponent: ReactNode
    }
}

export default function BasePrinter({
    printer,
}: BasePrinterProps) {
    return <Stack display={"none"}>
        <PrintThemeProvider>
            <Box ref={printer.printRef}>
                {printer.printComponent}
            </Box>
        </PrintThemeProvider>
    </Stack>
}